export default function HowItWorksPage() {
  return (
    <div className="min-h-screen bg-slate-950 text-white p-12">
      <h1 className="text-6xl font-black mb-6">How It Works</h1>
      <p className="text-white/70 max-w-2xl">
        This page explains real operational flows, not marketing fluff.
      </p>
    </div>
  );
}
